import { render, staticRenderFns } from "./SettingsPopupBase.vue?vue&type=template&id=1bc081ec&"
import script from "./SettingsPopupBase.vue?vue&type=script&lang=js&"
export * from "./SettingsPopupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc081ec')) {
      api.createRecord('1bc081ec', component.options)
    } else {
      api.reload('1bc081ec', component.options)
    }
    module.hot.accept("./SettingsPopupBase.vue?vue&type=template&id=1bc081ec&", function () {
      api.rerender('1bc081ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/SettingsPopupBase.vue"
export default component.exports